module.exports = __webpack_public_path__ + "static/img/cm-maha.2d40540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cm-maha.jpg
// module id = QtGz
// module chunks = 0